const partialInches = [
  {
    label: '0',
    value: '.000',
  },
  {
    label: '1/8',
    value: '.125',
  },
  {
    label: '1/4',
    value: '.250',
  },
  {
    label: '3/8',
    value: '.375',
  },
  {
    label: '1/2',
    value: '.500',
  },
  {
    label: '5/8',
    value: '.625',
  },
  {
    label: '3/4',
    value: '.750',
  },
  {
    label: '7/8',
    value: '.875',
  },
];

const getInchOptionsRange =  (min, max) => {
  let options = '<option value="any">Any</option>';
  for (let i = min; i <= max; i++) { /* eslint-disable-line no-plusplus */
    options += `<option value="${i}">${i}</option>`;
  }
  return options;
};

const getPartialInchOptions = () => {
  let options = '';
  partialInches.forEach((item, index) => {
    if (index === 0) {
      options += `<option selected="selected" value="${item.value}">${item.label}</option>`;
    } else {
      options += `<option value="${item.value}">${item.label}</option>`;
    }
  });
  return options;
};

const appendZeroes = (num) => {
  const zeroes = '000';
  if (num.length < 3) {
    return `${num}${zeroes.substr(0, 3 - num.length)}`;
  }
  return num;
};

const getPartialDimensionValue = (id, data) => {
  let arr = [];
  let val = '';
  switch (id) {
    case 'Width1':
      arr = data.windowWidth.toString().split('.');
      if (arr[0]) {
        val = arr[0]; /* eslint-disable-line prefer-destructuring */
      } else {
        val = 'any';
      }
      if (val === '0') {
        val = 'any';
      }
      break;
    case 'Width2':
      arr = data.windowWidth.toString().split('.');
      if (arr[1]) {
        val = `.${appendZeroes(arr[1])}`;
      } else {
        val = '.000';
      }
      break;
    case 'Height1':
      arr = data.windowHeight.toString().split('.');
      if (arr[0]) {
        val = arr[0]; /* eslint-disable-line prefer-destructuring */
      } else {
        val = 'any';
      }
      if (val === '0') {
        val = 'any';
      }
      break;
    case 'Height2':
      arr = data.windowHeight.toString().split('.');
      if (arr[1]) {
        val = `.${appendZeroes(arr[1])}`;
      } else {
        val = '.000';
      }
      break;
    default:
      val = '';
  }
  return val;
};

export {
  getInchOptionsRange,
  getPartialDimensionValue,
  getPartialInchOptions,
};
